
    import * as React from 'react';

    const Ruler16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M1 9.249l11.753-6.786 2.5 4.33L3.5 13.579 1 9.249zm.976.261l1.785 3.093L14.277 6.53l-1.785-3.09L1.976 9.51zm1.237-.714l.619-.357 1.07 1.855-.618.357-1.071-1.855zM8.78 5.58l.619-.357.714 1.237-.618.358L8.78 5.58zM6.924 6.653l.619-.357L8.614 8.15l-.618.358-1.072-1.856zm3.712-2.143l.619-.357 1.071 1.856-.619.357-1.071-1.856zM5.069 7.724l.618-.357.715 1.237-.619.357-.714-1.237z" /></svg>
        </div>
      );
    };

    Ruler16.displayName = 'Ruler16';

    export default Ruler16;
  